const UPDATES = [
  { date: '07-28', title: '霸道总裁的甜蜜契约', chapter: '第128话', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '校草大人请多指教', chapter: '第95话', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '青梅竹马的恋爱日记', chapter: '第76话', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '樱花树下的约定', chapter: '第53话', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '我的恶魔男友', chapter: '第112话', type: '新作', typeColor: 'bg-accent-100 text-accent-700' },
  { date: '07-26', title: '总裁大人有点甜', chapter: '第89话', type: '更新', typeColor: 'bg-primary-100 text-primary-700' },
  { date: '07-25', title: '邻家少女恋爱中', chapter: '第67话', type: '新作', typeColor: 'bg-accent-100 text-accent-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            最近更新
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">热门漫画最新话实时追踪</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {UPDATES.map((item, idx) => (
            <a
              key={idx}
              href="#updates"
              className="flex items-center gap-4 py-4 border-b border-background-200/70 last:border-b-0 hover:bg-primary-50/30 px-3 rounded-lg transition-colors cursor-pointer group"
            >
              <span className="text-xs font-bold text-foreground-500 w-12 shrink-0">{item.date}</span>
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium shrink-0 ${item.typeColor}`}>{item.type}</span>
              <span className="flex-1 text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                {item.title}
              </span>
              <span className="text-sm font-bold text-primary-500 shrink-0">{item.chapter}</span>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#updates" className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer">
            查看更多更新 <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}